import request from '@/utils/shortRequest'

const delay = (data, ms = 180) => new Promise(resolve => window.setTimeout(() => resolve(data), ms))
const rejectDelay = (error, ms = 1000) => new Promise((resolve, reject) => window.setTimeout(() => reject(error), ms))
const latestPrizeImage = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72"%3E%3Ccircle cx="36" cy="36" r="36" fill="%23d92f24"/%3E%3Ccircle cx="36" cy="36" r="24" fill="%23ffd85a"/%3E%3C/svg%3E'

function createMockState () {
  return {
    entry: {
      mowang_no: 'MW2026',
      nickname: '默往球迷',
      coin_balance: 88,
      in_blacklist: false,
      ticket_coin: 6,
      remaining_draw: 2
    },
    draw_index: 0,
    center_load_count: 0,
    matches: [
      ['R16-1', 1, 1, '巴西', '克罗地亚', 2, 80, 20],
      ['R16-2', 1, 2, '法国', '墨西哥', 2, 64, 36],
      ['R16-3', 1, 3, '阿根廷', '美国', 1, 0, 0],
      ['R16-4', 1, 4, '英格兰', '日本', 3, 58, 42],
      ['R16-5', 1, 5, '德国', '摩洛哥', 4, 45, 55],
      ['R16-6', 1, 6, '西班牙', '乌拉圭', 3, 52, 48],
      ['R16-7', 1, 7, '葡萄牙', '荷兰', 4, 50, 50],
      ['R16-8', 1, 8, '意大利', '加拿大', 3, 50, 50],
      ['QF-1', 2, 1, '胜者 1', '胜者 2', 1, 0, 0],
      ['QF-2', 2, 2, '胜者 3', '胜者 4', 1, 0, 0],
      ['QF-3', 2, 3, '胜者 5', '胜者 6', 1, 0, 0],
      ['QF-4', 2, 4, '胜者 7', '胜者 8', 1, 0, 0],
      ['SF-1', 3, 1, '胜者 9', '胜者 10', 1, 0, 0],
      ['SF-2', 3, 2, '胜者 11', '胜者 12', 1, 0, 0],
      ['THIRD', 4, 1, '半决赛负者', '半决赛负者', 1, 0, 0],
      ['FINAL', 5, 1, '半决赛胜者', '半决赛胜者', 1, 0, 0]
    ].map((item, index) => ({
      match_key: item[0],
      round: item[1],
      seq: item[2],
      team_a: item[3],
      team_b: item[4],
      team_a_flag: '',
      team_b_flag: '',
      deadline_time: Math.floor(Date.now() / 1000) + (index + 1) * 3600,
      status: item[5],
      winner: item[5] === 4 ? item[7] > item[6] ? 'B' : 'A' : '',
      result_score: item[5] === 4 ? '2-1' : '',
      count_a: item[6],
      count_b: item[7],
      percent_a: item[6],
      percent_b: item[7],
      phase: index === 3 ? 'running' : '',
      live_minute: index === 3 ? 67 : 0,
      _celebrated: index === 6,
      my_bet: index === 1
        ? { chosen_side: 1, chosen_team: item[3], hit_result: 0, ticket_coin: 6 }
        : index === 4
          ? { chosen_side: 1, chosen_team: item[3], hit_result: 2, ticket_coin: 6 }
          : index === 6 ? { chosen_side: 1, chosen_team: item[3], hit_result: 1, ticket_coin: 6 } : null
    })),
    prizes: [
      { slot: 1, name: '会员 30 天', type: 1, grant_amount: 30, image: '' },
      { slot: 2, name: '群发次数 10 次', type: 2, grant_amount: 10, image: '' },
      { slot: 3, name: '超级群优惠券', type: 3, grant_amount: 1, image: '' },
      { slot: 4, name: '8 默往币', type: 4, grant_amount: 8, image: '' },
      { slot: 5, name: '群发次数 20 次', type: 2, grant_amount: 20, image: '' },
      { slot: 6, name: '会员 30 天', type: 1, grant_amount: 30, image: '' },
      { slot: 7, name: '18 默往币', type: 4, grant_amount: 18, image: '' },
      { slot: 8, name: '超级群一个月优惠券', type: 3, grant_amount: 1, image: '' }
    ],
    records: []
  }
}

let mockState = createMockState()
let lowBalanceApplied = false
let priceChangeApplied = false
let mockFailOnceState = {}
let mockCase = ''

function isMockMode () {
  if (typeof window === 'undefined') return false
  const hostname = window.location.hostname
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1'
  return isLocalHost && /(?:\?|&)mock=1(?:&|$)/.test(window.location.search)
}

function hasMockFlag (name) {
  if (typeof window === 'undefined') return false
  return new RegExp(`(?:\\?|&)${name}=1(?:&|$)`).test(window.location.search)
}

function mockQueryValue (name) {
  if (typeof window === 'undefined') return ''
  const match = window.location.search.match(new RegExp(`(?:\\?|&)${name}=([^&]*)`))
  return match ? decodeURIComponent(match[1]) : ''
}

function ensureMockState () {
  const currentCase = mockQueryValue('case')
  if (currentCase !== mockCase) {
    mockState = createMockState()
    lowBalanceApplied = false
    priceChangeApplied = false
    mockFailOnceState = {}
    mockCase = currentCase
  }
  if (hasMockFlag('noBets')) {
    mockState.matches.forEach(item => {
      item.my_bet = null
      item._celebrated = true
    })
  }
  if (hasMockFlag('celebration')) {
    const match = mockState.matches.find(item => item.match_key === 'R16-6')
    if (match && !match._celebrationSeeded) {
      match.status = 4
      match.winner = 'A'
      match.result_score = '2-1'
      match.my_bet = {
        chosen_side: 1,
        chosen_team: match.team_a,
        hit_result: 1,
        ticket_coin: mockState.entry.ticket_coin
      }
      match._celebrationSeeded = true
    }
  }
  if (hasMockFlag('multiCelebration')) {
    const match = mockState.matches.find(item => item.match_key === 'R16-7')
    if (match && !match._multiCelebrationSeeded) {
      match._celebrated = false
      match._multiCelebrationSeeded = true
    }
  }
  if (hasMockFlag('noChance')) {
    mockState.entry.remaining_draw = 0
  }
}

function ok (data) {
  return { code: 200, data, msg: '' }
}

function shouldMockFailOnce (name) {
  if (!hasMockFlag(name) || mockFailOnceState[name]) return false
  mockFailOnceState[name] = true
  return true
}

function syncMatchPercents (match) {
  const countA = Number(match.count_a) || 0
  const countB = Number(match.count_b) || 0
  const total = countA + countB
  if (total <= 0) {
    match.percent_a = 0
    match.percent_b = 0
    return
  }
  let percentA = Math.round(countA * 100 / total)
  let percentB = Math.round(countB * 100 / total)
  const diff = 100 - percentA - percentB
  if (diff !== 0) {
    if (countA >= countB) percentA += diff
    else percentB += diff
  }
  match.percent_a = percentA
  match.percent_b = percentB
}

function nextKey (prefix) {
  return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

function mockGetEntry () {
  ensureMockState()
  const ms = hasMockFlag('slowEntry') ? 3000 : 180
  if (hasMockFlag('entryError') || shouldMockFailOnce('entryErrorOnce')) {
    return delay({ code: 10919, data: null, msg: 'token失效,请重新登陆' }, ms)
  }
  return delay(ok(Object.assign({}, mockState.entry, {
    in_blacklist: hasMockFlag('blacklist') || mockState.entry.in_blacklist
  })), ms)
}

function mockGetBalance () {
  ensureMockState()
  if (hasMockFlag('lowBalance') && !lowBalanceApplied) {
    mockState.entry.coin_balance = 0
    lowBalanceApplied = true
  }
  return delay(ok({
    coin_balance: mockState.entry.coin_balance
  }))
}

function mockGetMatches () {
  ensureMockState()
  if (shouldMockFailOnce('matchesErrorOnce')) {
    return delay({ code: 500, data: null, msg: '赛程加载失败' })
  }
  return delay(ok(mockState.matches.map(item => Object.assign({}, item, {
    my_bet: item.my_bet ? Object.assign({}, item.my_bet) : null
  }))))
}

function mockBet (data) {
  ensureMockState()
  if (hasMockFlag('betTimeout')) {
    return rejectDelay({ message: '网络异常，请稍后确认是否参与成功' })
  }
  if (hasMockFlag('priceChange') && !priceChangeApplied) {
    priceChangeApplied = true
    mockState.entry.ticket_coin += 2
    return delay({ code: 634, data: { ticket_coin: mockState.entry.ticket_coin }, msg: '门票价格有变动，请确认后再参与' })
  }
  const match = mockState.matches.find(item => item.match_key === data.match_key)
  if (hasMockFlag('repeatBet') && match && !match.my_bet) {
    const chosenTeam = data.chosen_side === 2 ? match.team_b : match.team_a
    match.my_bet = {
      chosen_side: data.chosen_side,
      chosen_team: chosenTeam,
      hit_result: 0,
      ticket_coin: mockState.entry.ticket_coin
    }
    return delay({ code: 633, data: null, msg: '本场已参与' })
  }
  if (!match || match.status !== 2 || match.my_bet) {
    return delay({ code: match && match.my_bet ? 633 : 632, data: null, msg: match && match.my_bet ? '本场已参与' : '场次未开放或已截止' })
  }
  if (data.ticket_coin !== mockState.entry.ticket_coin) {
    return delay({ code: 634, data: null, msg: '门票价格有变动，请确认后再参与' })
  }
  if (mockState.entry.coin_balance < data.ticket_coin) {
    return delay({ code: 602, data: null, msg: '余额不足' })
  }
  const chosenTeam = data.chosen_side === 2 ? match.team_b : match.team_a
  mockState.entry.coin_balance -= data.ticket_coin
  match.my_bet = {
    chosen_side: data.chosen_side,
    chosen_team: chosenTeam,
    hit_result: 0,
    ticket_coin: data.ticket_coin
  }
  if (data.chosen_side === 2) match.count_b += 1
  else match.count_a += 1
  syncMatchPercents(match)
  return delay(ok({
    match_key: match.match_key,
    chosen_side: data.chosen_side,
    chosen_team: chosenTeam,
    ticket_coin: data.ticket_coin,
    coin_balance: mockState.entry.coin_balance
  }), 500)
}

function mockCelebrations () {
  ensureMockState()
  const wins = mockState.matches.filter(item => item.my_bet && item.my_bet.hit_result === 1 && !item._celebrated)
  wins.forEach(item => { item._celebrated = true })
  return delay(ok(wins))
}

function mockLotteryCenter () {
  ensureMockState()
  if (shouldMockFailOnce('lotteryCenterErrorOnce')) {
    return delay({ code: 500, data: null, msg: '抽奖中心加载失败' })
  }
  mockState.center_load_count += 1
  if (hasMockFlag('latestPrize') && mockState.center_load_count > 1) {
    const prize = mockState.prizes.find(item => item.slot === 7)
    if (prize) {
      prize.name = '后台最新 18 默往币'
      prize.image = latestPrizeImage
    }
  }
  return delay(ok({
    remaining: mockState.entry.remaining_draw,
    prizes: hasMockFlag('prizeInvalid') ? mockState.prizes.slice(0, 7) : mockState.prizes
  }))
}

function mockDraw () {
  ensureMockState()
  if (hasMockFlag('drawInvalid')) {
    return delay({ code: 636, data: null, msg: '奖品池配置未完成，暂不可抽奖' })
  }
  if (mockState.entry.remaining_draw <= 0) {
    return delay({ code: 635, data: null, msg: '无抽奖机会' })
  }
  const slots = mockQueryValue('drawSlots')
    .split(',')
    .map(item => Number(item))
    .filter(item => item >= 1 && item <= 8)
  const slot = slots.length
    ? slots[Math.min(mockState.draw_index, slots.length - 1)]
    : Number(mockQueryValue('drawSlot'))
  const prize = mockState.prizes.find(item => item.slot === slot) || mockState.prizes[Math.floor(Math.random() * mockState.prizes.length)]
  mockState.draw_index += 1
  mockState.entry.remaining_draw -= 1
  mockState.records.unshift({
    prize_slot: prize.slot,
    prize_name: prize.name,
    prize_type: prize.type,
    prize_amount: prize.grant_amount,
    image: prize.image,
    grant_status: 1,
    create_time: Math.floor(Date.now() / 1000),
    idempotency_key: nextKey('record')
  })
  return delay(ok({
    prize_slot: prize.slot,
    prize_name: prize.name,
    prize_type: prize.type,
    prize_amount: prize.grant_amount,
    grant_status: 1,
    remaining: mockState.entry.remaining_draw
  }), 900)
}

function mockRecords () {
  ensureMockState()
  return delay(ok(mockState.records.map(item => Object.assign({}, item))))
}

function mockRules () {
  ensureMockState()
  if (hasMockFlag('rulesNetworkError') || shouldMockFailOnce('rulesNetworkErrorOnce')) {
    return rejectDelay({ message: 'Network Error', code: 'ERR_NETWORK', request: { status: 0 } }, 180)
  }
  if (shouldMockFailOnce('rulesErrorOnce')) {
    return delay({ code: 500, data: null, msg: '规则加载失败' })
  }
  return delay(ok({
    rules_html: '<h3>活动规则</h3><p>每场竞猜消耗门票默往币，猜中即可获得 1 次抽奖机会。</p><p>奖品以抽奖中心展示为准，100% 中奖。</p>'
  }))
}

export function createIdempotencyKey (prefix) {
  return nextKey(prefix)
}

export function rechargeMockBalance (coin) {
  if (!isMockMode()) return 0
  ensureMockState()
  const nextBalance = Math.max(Number(mockState.entry.coin_balance) || 0, Number(coin) || 0)
  mockState.entry.coin_balance = nextBalance
  return mockState.entry.coin_balance
}

export function getEntry (options = {}) {
  if (isMockMode()) return mockGetEntry()
  return request({ url: '/worldcup/quiz/entry', method: 'get', ...options })
}

export function getBalance () {
  if (isMockMode()) return mockGetBalance()
  return request({ url: '/worldcup/quiz/balance', method: 'get' })
}

export function getMatches (options = {}) {
  if (isMockMode()) return mockGetMatches()
  return request({ url: '/worldcup/quiz/matches', method: 'get', ...options })
}

export function bet (data) {
  if (isMockMode()) return mockBet(data)
  return request({ url: '/worldcup/quiz/bet', method: 'post', data, timeout: 30000 })
}

export function getMyBets (options = {}) {
  if (isMockMode()) {
    ensureMockState()
    if (hasMockFlag('myBetsNetworkError') || shouldMockFailOnce('myBetsNetworkErrorOnce')) {
      return rejectDelay({ message: 'Network Error', code: 'ERR_NETWORK', request: { status: 0 } }, 180)
    }
    if (shouldMockFailOnce('myBetsErrorOnce')) {
      return delay({ code: 500, data: null, msg: '我的竞猜加载失败' })
    }
    return delay(ok(mockState.matches.filter(item => item.my_bet)))
  }
  return request({ url: '/worldcup/quiz/my-bets', method: 'get', ...options })
}

export function getCelebrations (options = {}) {
  if (isMockMode()) return mockCelebrations()
  return request({ url: '/worldcup/quiz/celebrations', method: 'get', ...options })
}

export function getLotteryCenter (options = {}) {
  if (isMockMode()) return mockLotteryCenter()
  return request({ url: '/worldcup/quiz/lottery/center', method: 'get', ...options })
}

export function draw (data) {
  if (isMockMode()) return mockDraw(data)
  return request({ url: '/worldcup/quiz/lottery/draw', method: 'post', data, timeout: 30000 })
}

export function getLotteryRecords (params = {}, options = {}) {
  if (isMockMode()) return mockRecords()
  return request({ url: '/worldcup/quiz/lottery/records', method: 'get', params, ...options })
}

export function getRules (options = {}) {
  if (isMockMode()) return mockRules()
  return request({ url: '/worldcup/quiz/rules', method: 'get', ...options })
}
